export enum AuthRoles {
  PetPass_Admin = 1,
  PetPass_CSR = 2,
  PetPass_CSR_L2 = 3,
  PetPass_Greeter = 4,
  PetPass_DVM = 5,
  PetPass_VetTech = 6,
  PetPass_DI = 7,
  PetPass_Ops_Leader = 10,
  PetPass_ReadOnly = 13,
  Admin = 22,
  Veterinarian = 23,
  VeterinaryTechnician = 24,
  VeterinaryAssistant = 25,
  HospitalOfficeManager = 26,
  AreaOfficeManager = 27,
  Concierge_CustomerService = 28,
  HospitalMedicalLeader = 29,
  LeaderonDuty = 30,
  AreaMedicalDirector = 31,
}
